module.exports = "<div class=\"vis-toolbar\">\n  <div class=\"vis-toolbar-left\">\n    <slot name=\"left\"></slot>\n  </div>\n  <div class=\"vis-toolbar-right\">\n    <slot name=\"right\">\n    </slot>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-visualisation/src/components/toolbar.html
// module id = 310
// module chunks = 0